import React from "react";
import Question from "./Question";
import Pagination from "@/components/pagination";
import en from "@/localization/en.json";
import InlineLoader from "@/components/loader/InlineLoader";
import { calculatePaginationIndices } from "@/utils/helpers/pagination";
import { useSession } from "next-auth/react";

function Questions({
  productQuestionData,
  getPaginatedQuestionData,
  isQuestionFetching,
}) {
  const { totalItems, totalPage, currentPage, perPage } =
    calculatePaginationIndices(productQuestionData?.meta);

  const { data: session } = useSession();
  const authToken = session?.token;

  return (
    <div className="relative">
      {isQuestionFetching && (
        <div className="absolute inset-0  bg-white/50">
          <InlineLoader className="w-[5rem] h-[5rem]" />
        </div>
      )}

      <div className="flex flex-col md:flex-row md:items-center justify-between mb-[2.25rem]">
        <div>
          <h5 className="text-[1.25rem] text-[#0A101A] mb-[1rem] font-semibold">
            {en["product.questions"]} {totalItems > 0 && `(${totalItems})`}
          </h5>
          <p className="text-grayD4 text-[0.938rem]">
            {en["product.have_question"]}
          </p>
        </div>
        {authToken && (
          <div className="mt-[1.5rem] md:mt-0">
            <label
              htmlFor="askProductQuestionModal"
              className="border-[2px] text-primary border-solid border-primary hover:border-[#CF1B57] active:border-[#CF1B57] rounded-[10px] font-medium cursor-pointer py-[.875rem] px-[2rem]"
            >
              {en["product.ask_a_question"]}
            </label>
          </div>
        )}
      </div>

      {productQuestionData?.questions.length > 0 ? (
        <>
          {productQuestionData.questions.map((question) => (
            <div key={question.uuid}>
              <Question question={question} />
              <div className="h-[1px] w-full bg-grayD8 mb-[1.75rem]"></div>
            </div>
          ))}
          {totalItems > perPage && (
            <div className="md:flex justify-end">
              <Pagination
                total={totalPage}
                currentPage={currentPage}
                getPaginateData={(pageNo) =>
                  getPaginatedQuestionData(pageNo + 1)
                }
              />
            </div>
          )}
        </>
      ) : (
        <div className=" min-h-[30vh] text-center font-bold text-2xl">
          No Question Available. Ask your first question
        </div>
      )}
    </div>
  );
}

export default Questions;
